import { Col, Row } from 'react-bootstrap'

import styles from './QuoteFull3.module.scss'

export type QuoteFull3Props = {
    quote: string
    author: string
    authorImage: string
    customClass?: string
}

export default function QuoteFull3({ quote, author, customClass, authorImage }: QuoteFull3Props) {
    const componentClass = `QuoteFull3 ${styles.QuoteFull3} ${customClass ?? ''}`

    return (
        <div className={componentClass}>
            <Row className="align-items-center gx-lg-6 gy-lg-0 gy-4">
                <Col md={3}>
                    <div className={styles.authorImg} style={{ backgroundImage: `url("${authorImage}")` }}></div>
                </Col>
                <Col md={9}>
                    <p className="quote">{quote}</p>
                    <p className="author fw-bold mb-0">{author}</p>
                </Col>
            </Row>
        </div>
    )
}
